import { render, staticRenderFns } from "./ButtonField.vue?vue&type=template&id=70eb1464&scoped=true"
import script from "./ButtonField.vue?vue&type=script&lang=js"
export * from "./ButtonField.vue?vue&type=script&lang=js"
import style0 from "./ButtonField.vue?vue&type=style&index=0&id=70eb1464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb1464",
  null
  
)

export default component.exports